/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */
// Import PolymerElement class
import {
    PolymerElement,
    html
} from "@polymer/polymer/polymer-element.js";
import {
    mixinBehaviors
} from "@polymer/polymer/lib/legacy/class.js"; // define the element's class element
// import "../../sb_transfer_ui/behaviors/authAndSubmit.js";
import "../../sb_transfer_ui/behaviors/authAndSubmit.js";

class profileContactDetailsLanding extends mixinBehaviors([sbBehaviours.currencyFormatorBehaviour, corpBehaviours.appCommonBehaviour], PolymerElement) {
    static get template() {
      return html`
           
      <style  include="app-styles">    
      </style>
      <app-media-query phone={{phone}} tablet={{tablet}} desktop={{desktop}}></app-media-query>
        <div class="mdl-grid mdl-grid--no-spacing" hidden$={{phone}}>
          <div class="mdl-cell mdl-cell--1-col-phone mdl-cell--2-col-tablet mdl-cell--3-col content-align-left text-align-left">
            <div hidden$="{{displayIcon(leftAction.leftIcon)}}">
              <a href="{{leftAction.lefthref}}" tabIndex="-1" hidden$="{{leftAction.leftCallback}}">
                <paper-icon-button icon="{{leftAction.leftIcon}}" class="action-btn-rtl"></paper-icon-button>
              </a>
              <div hidden$="{{!leftAction.leftCallback}}">
                <paper-icon-button id="profile_contact_landing_back_button" icon="{{leftAction.leftIcon}}" on-tap="_leftAction"  aria-label$="{{backButton}}" role="button" class="action-btn-rtl"></paper-icon-button>
              </div>
            </div>
          </div>
          <div class="mdl-cell mdl-cell--2-col-phone mdl-cell--4-col-tablet mdl-cell--6-col content-align-center text-align-center title-dark"
            >
            <oe-i18n-msg id="profile_landing_page_title" msgid="{{titlePage}}"></oe-i18n-msg>
          </div>
        </div>
      <paper-tabs selected="{{selectedContactType}}">
        <paper-tab id="profile_tab_address" class="outlineOffset">
          <oe-i18n-msg msgid="h_address" class="text-transform-uppercase"></oe-i18n-msg>
        </paper-tab>
        <paper-tab id="profile_tab_phone" class="outlineOffset">
          <oe-i18n-msg msgid="h_phone" class="text-transform-uppercase"></oe-i18n-msg>
        </paper-tab>
        <paper-tab id="profile_tab_email" class="outlineOffset">
          <oe-i18n-msg msgid="h_email" class="text-transform-uppercase"></oe-i18n-msg>
        </paper-tab>
      </paper-tabs>
  
      <iron-pages selected="{{selectedContactType}}">
        <div>
          <profile-contact-details-address-tab address-details="{{addressList}}" personal-details="{{personalDetails}}" address-details="{{addressDetails}}" myprofilepagenumber={{myprofilepagenumber}} personal-details-response="{{personalDetailsResponse}}" selected-contact-type={{selectedContactType}} selected-address-detail="{{selectedAddressDetail}}" from-edit-page="{{fromEditPage}}"></profile-contact-details-address-tab>
        </div>
        <div>
          <profile-contact-details-phone-tab comm-details="{{addressList}}" personal-details="{{personalDetails}}" selected-phone-details={{selectedPhoneDetails}} myprofilepagenumber={{myprofilepagenumber}} selected-contact-type={{selectedContactType}} from-phone-edit-page="{{fromPhoneEditPage}}" personal-details-response="{{personalDetailsResponse}}" ></profile-contact-details-phone-tab>
        </div>
        <div>
          <profile-contact-details-email-tab comm-details="{{addressList}}" personal-details="{{personalDetails}}" selected-email-details={{selectedEmailDetails}} myprofilepagenumber={{myprofilepagenumber}} selected-contact-type={{selectedContactType}} from-email-edit-page="{{fromEmailEditPage}}" personal-details-response="{{personalDetailsResponse}}"></profile-contact-details-email-tab>
        </div>
      </iron-pages>
            `;
    }
  
    static get properties() {
      return {
      //set aria label to back button
	 backButton: {
	        type: String,
	        notify: true,
	        value: getLabel('b_Back')
	 },
          //selected contact type
        selectedContactType: {
          type: Number,
          notify: true,
          value: 0
        },
        //for title of page
        titlePage: {
          type: String,
          notify: true
        },
        //change iron page
        myprofilepagenumber: {
          type: Number,
          notify: true
        },
        //selected adress detail
        selectedAddressDetail: {
          type: Object,
          notify: true
        },
        //all address detail
        addressDetails: {
          type: Object,
         notify:true
      },
      //To store selected phone details
      selectedPhoneDetails: {
        type: Object,
        notify: true
      },
      //To store selected email details
      selectedEmailDetails: {
        type: Object,
        notify: true
      },
      //To store all the address and contact details
      addressList: {
        type: Array,
        notify: true
        },
        commDetails: {
          type: Array,
          notify: true
        },
        personalDetails: {
          type: Array,
          notify: true
        },
        personalDetailsResponse: {
          type: Array,
          notify: true,
          observer: "addressResponse"
        },
        fromEditPage: {
          type: Boolean,
          notify: true
      },
      fromPhoneEditPage: {
        type: Boolean,
        notify: true
      },
      fromEmailEditPage: {
        type: Boolean,
        notify: true
      }
  
      };
    }
  //Function to navigate to the previous page
   //function to take response
  addressResponse() {
    this.personalDetails = this.personalDetailsResponse;
    }

    _leftAction() {
      this.myprofilepagenumber = 0;
    }
  
  //Function to show the back icon
    displayIcon(value) {
      if (value == "") return true;
      return false;
    }
  
    //Manually Focused on Header
    _focusOnTitle() {
      if (this.phone && $('.mainContent') !== undefined) {
        $('.mainContent')[0].style.marginBottom = "0px";
        $('#index_HeaderPanel')[0].children[1].style.marginTop = "8px";
        $('#index_HeaderPanel')[0].children[1].classList.remove('page-container-min-height');
    }
      setTimeout(function () {
        this.$$("#profile_landing_page_title").setAttribute("tabindex", "0");
        this.$$("#profile_landing_page_title").focus();
      }.bind(this), 1000);
    }
  } // Associate the new class with an element name


customElements.define('profile-contact-details-landing', profileContactDetailsLanding);